import { CutLineStrategy } from "@opstel/geo/GetLinePartsStrategies/CutLineStrategy";
import { Path } from "@opstel/geo/Path";
import { Point } from "@opstel/geo/Point";

type GetPlanTrainUnitTextPathsResult = {
  mainTextPath: Path;
  subTextPath: Path;
  bgPath: Path;
};

type LabelContext = {
  type: "mainText" | "subText";
};

export function getPlanTrainUnitTextPaths(
  mainTextWidth: number,
  subTextWidth: number,
  textPoints: Point[],
  trackLineWidth: number,
): GetPlanTrainUnitTextPathsResult {
  const path = new Path(textPoints);

  const textPathCorrection = 2 * trackLineWidth; // the text on the path is not exactly the same as the text in the Konva.Text object, so we need to correct for that..
  const textMargin = 5 * trackLineWidth;

  const strategy = new CutLineStrategy([
    { type: "*" }, // fill the remaining space
    { type: "px", value: textMargin, precedence: 3 }, // some space before the texts
    {
      type: "px",
      value: mainTextWidth + textPathCorrection,
      precedence: 2,
      context: { type: "mainText" } as LabelContext,
    },
    {
      type: "px",
      value: subTextWidth + textPathCorrection,
      precedence: 1,
      hideIfShortened: true,
      context: { type: "subText" } as LabelContext,
    },
    { type: "px", value: textMargin, precedence: 3 }, // some space after the texts
    { type: "*" }, // fill the remaining space
  ]);

  const textPaths = path
    .getPathSegments(strategy, (ctx) => ctx !== undefined)
    .reduce((acc, current) => {
      return {
        ...acc,
        [`${current.context!.type}Path`]: current.path,
      };
    }, {}) as Omit<GetPlanTrainUnitTextPathsResult, "bgPath">;

  // the background path is the combination of the main and sub text paths
  const bgPath = new Path([...textPaths.mainTextPath.points, ...textPaths.subTextPath.points]);

  return {
    ...textPaths,
    bgPath,
  };
}
